import api from './api';

const benchmarkService = {
  /**
   * Get list of available benchmarks
   */
  async getBenchmarks() {
    const response = await api.get('/benchmarks');
    return response.data;
  },

  /**
   * Get monthly returns for a benchmark
   * @param {string} symbol - Benchmark symbol (e.g., SPY)
   * @param {object} options - { startYear, endYear }
   */
  async getMonthlyReturns(symbol = 'SPY', options = {}) {
    const response = await api.get(`/benchmarks/${symbol}/monthly-returns`, { params: options });
    return response.data;
  },

  /**
   * Get monthly returns formatted for heatmap display
   * @param {string} symbol - Benchmark symbol (e.g., SPY)
   */
  async getHeatmapData(symbol = 'SPY') {
    const response = await api.get(`/benchmarks/${symbol}/heatmap`);
    return response.data;
  },

  /**
   * Seed S&P 500 historical data (admin)
   */
  async seedData() {
    const response = await api.post('/benchmarks/seed');
    return response.data;
  },

  /**
   * Update a single month's return
   * @param {string} symbol - Benchmark symbol
   * @param {string} period - Period label (YYYY-MM)
   * @param {number} returnPct - Return percentage
   * @param {string} source - Data source
   */
  async updateMonthlyReturn(symbol, period, returnPct, source = 'manual') {
    const response = await api.put(`/benchmarks/${symbol}/monthly-returns/${period}`, {
      return_pct: returnPct,
      source
    });
    return response.data;
  }
};

export default benchmarkService;
